import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d673788c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header header-surface" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1 text-primary px-3 py-1 rounded" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-6 me-4"
}
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = {
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "shimmer h-120 mb-2 rounded-3"
}
const _hoisted_12 = {
  key: 1,
  class: "stats-sections"
}
const _hoisted_13 = { class: "col-section" }
const _hoisted_14 = {
  key: 0,
  class: "stat"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"row-top\" data-v-d673788c><div class=\"icon purple\" data-v-d673788c><img src=\"/media/icons/dash/land.png\" alt=\"Map Land\" width=\"20\" height=\"20\" data-v-d673788c></div><div class=\"label\" data-v-d673788c><span class=\"brand\" data-v-d673788c>Map</span> - <b data-v-d673788c>Land</b></div></div>", 1)
const _hoisted_16 = { class: "row-bottom" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 1,
  class: "row-divider"
}
const _hoisted_19 = {
  key: 2,
  class: "stat"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"row-top\" data-v-d673788c><div class=\"icon purple\" data-v-d673788c><img src=\"/media/icons/dash/land.png\" alt=\"Manual Land\" width=\"20\" height=\"20\" data-v-d673788c></div><div class=\"label\" data-v-d673788c><span class=\"brand\" data-v-d673788c>Manual</span> - <b data-v-d673788c>Land</b></div></div>", 1)
const _hoisted_21 = { class: "row-bottom" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "col-section" }
const _hoisted_24 = {
  key: 0,
  class: "stat"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"row-top\" data-v-d673788c><div class=\"icon purple\" data-v-d673788c><img src=\"/media/icons/dash/building.png\" alt=\"Map Building\" width=\"20\" height=\"20\" data-v-d673788c></div><div class=\"label\" data-v-d673788c><span class=\"brand\" data-v-d673788c>Map</span> - <b data-v-d673788c>Building</b></div></div>", 1)
const _hoisted_26 = { class: "row-bottom" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = {
  key: 1,
  class: "row-divider"
}
const _hoisted_29 = {
  key: 2,
  class: "stat"
}
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"row-top\" data-v-d673788c><div class=\"icon purple\" data-v-d673788c><img src=\"/media/icons/dash/building.png\" alt=\"Manual Building\" width=\"20\" height=\"20\" data-v-d673788c></div><div class=\"label\" data-v-d673788c><span class=\"brand\" data-v-d673788c>Manual</span> - <b data-v-d673788c>Building</b></div></div>", 1)
const _hoisted_31 = { class: "row-bottom" }
const _hoisted_32 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card', _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.translate('hisbaRealtyStats')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedPeriod === 'custom')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(`${_ctx.customDateFrom} till ${_ctx.customDateTo}`), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.selectedPeriod), 1),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectPeriod('yesterday')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('yesterday')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-7-days' }]),
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-7-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last7Days')), 3)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-30-days' }]),
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-30-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last30Days')), 3)
            ]),
            _hoisted_9,
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'custom' }]),
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showCustomDatePicker()), ["prevent"]))
              }, _toDisplayString(_ctx.translate('customRange')), 3)
            ])
          ])
        ]),
        _createVNode(_component_CustomDatePicker, {
          show: _ctx.showDatePicker,
          dateFrom: _ctx.customDateFrom,
          "onUpdate:dateFrom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customDateFrom) = $event)),
          dateTo: _ctx.customDateTo,
          "onUpdate:dateTo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customDateTo) = $event)),
          onApply: _ctx.applyCustomDates,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDatePicker = false))
        }, null, 8, ["show", "dateFrom", "dateTo", "onApply"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.mapLandData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatCount(_ctx.mapLandData.count)), 1),
                      (_ctx.mapLandData.countPercentage > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["trend", _ctx.trendClass(_ctx.mapLandData.countChange)])
                          }, _toDisplayString(Math.abs(_ctx.mapLandData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.mapLandData.countChange)), 3))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.mapLandData && _ctx.manualLandData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                : _createCommentVNode("", true),
              (_ctx.manualLandData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatCount(_ctx.manualLandData.count)), 1),
                      (_ctx.manualLandData.countPercentage > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["trend", _ctx.trendClass(_ctx.manualLandData.countChange)])
                          }, _toDisplayString(Math.abs(_ctx.manualLandData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.manualLandData.countChange)), 3))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_ctx.mapBuildingData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatCount(_ctx.mapBuildingData.count)), 1),
                      (_ctx.mapBuildingData.countPercentage > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["trend", _ctx.trendClass(_ctx.mapBuildingData.countChange)])
                          }, _toDisplayString(Math.abs(_ctx.mapBuildingData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.mapBuildingData.countChange)), 3))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.mapBuildingData && _ctx.manualBuildingData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                : _createCommentVNode("", true),
              (_ctx.manualBuildingData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formatCount(_ctx.manualBuildingData.count)), 1),
                      (_ctx.manualBuildingData.countPercentage > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["trend", _ctx.trendClass(_ctx.manualBuildingData.countChange)])
                          }, _toDisplayString(Math.abs(_ctx.manualBuildingData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.manualBuildingData.countChange)), 3))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ], 2))
}